import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';

const ExampleCard = () => (
  <Col md={12}>
    <Card>
      <CardBody>
        <div className="card__title">
          <h5 className="bold-text">Malla</h5>
          <h5 className="subhead">Facultad de Ingenieria</h5>
        </div>
        <p>P&aacute;gina en Construcci&oacute;n!</p>
      </CardBody>
    </Card>
  </Col>
);

export default ExampleCard;
